import { render, staticRenderFns } from "./PlayerTecnoquimicas.vue?vue&type=template&id=4b7dc524&scoped=true&"
import script from "./PlayerTecnoquimicas.vue?vue&type=script&lang=js&"
export * from "./PlayerTecnoquimicas.vue?vue&type=script&lang=js&"
import style0 from "./PlayerTecnoquimicas.vue?vue&type=style&index=0&id=4b7dc524&lang=scss&scoped=true&"
import style1 from "./PlayerTecnoquimicas.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./PlayerTecnoquimicas.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7dc524",
  null
  
)

export default component.exports